import { useEffect, useState } from 'react';
import { accumulate, queryString } from '@olivierpascal/helpers';
import { useLocation, useSearchParams } from 'react-router-dom';

import type { ITrackedUtmCampaignContextValue } from './TrackedUtmCampaignContext';
import { useNavigate } from '~/components/utils/Navigation';
import { TrackedUtmCampaignContext } from './TrackedUtmCampaignContext';

export type ITrackedUtmCampaignProps = {
  component: React.ReactElement;
};

export const TrackedUtmCampaign: React.FC<ITrackedUtmCampaignProps> = ({
  component,
}) => {
  const [searchParams] = useSearchParams();
  const utmCampaign = searchParams.get('utm_campaign') || undefined;
  const utmMedium = searchParams.get('utm_medium') || undefined;
  const utmSource = searchParams.get('utm_source') || undefined;
  const utmTerm = searchParams.get('utm_term') || undefined;
  const utmContent = searchParams.get('utm_content') || undefined;
  const [utm, setUtm] = useState<ITrackedUtmCampaignContextValue>({});
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(
    () =>
      setUtm((utm) =>
        accumulate(utm, {
          campaign: utmCampaign,
          medium: utmMedium,
          source: utmSource,
          term: utmTerm,
          content: utmContent,
        }),
      ),
    [utmCampaign, utmMedium, utmSource, utmTerm, utmContent],
  );

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const filteredSearchParams = [...searchParams.entries()].reduce(
      (acc, [key, value]) =>
        key.startsWith('utm_') ? acc : { ...acc, [key]: value },
      {},
    );
    const filteredQueryString = queryString.build(filteredSearchParams);
    const newUrl = `${location.pathname}${filteredQueryString ? `?${filteredQueryString}` : ''}`;
    const currentUrl = `${location.pathname}${location.search}`;
    if (newUrl !== currentUrl) {
      navigate(newUrl);
    }
  }, [location, navigate, utm]);

  return (
    <TrackedUtmCampaignContext.Provider value={utm}>
      {component}
    </TrackedUtmCampaignContext.Provider>
  );
};
